import { render } from "./NotFound.vue?vue&type=template&id=6d193711&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=6d193711&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Esther Ibom\\Desktop\\vue-exam\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d193711"]])

export default __exports__